import React, { FormEvent } from "react";
import { api, DepositTypeDto } from "shared/api";
import { useApiMethod, UseModalProps } from "shared/lib";
import { Entity, LoadingDots, Modal, Error } from "shared/ui";

export interface IDepositTypeDeleteModal extends UseModalProps {
  companySlug: string;
  data: DepositTypeDto;
}

export const DepositTypeDeleteModal = (props: IDepositTypeDeleteModal) => {
  const depositTypeList = api.depositType.useDepositTypeList(props.companySlug);
  const submit = useApiMethod(api.depositType.depositTypeArchive);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    await submit.call(props.companySlug, props.data.id);
    await depositTypeList.mutate();
    await props.onSuccess();
  };

  return (
    <Modal onClose={props.close} width={400}>
      <form onSubmit={onSubmit}>
        <Modal.Header>
          <Modal.Title>Удалить источник внедоходных поступлений</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Entity>
            <Entity.Field title={props.data.name} />
          </Entity>

          {submit.error && <Error style={{ marginTop: 24 }}>{submit.error.message}</Error>}
        </Modal.Body>

        <Modal.Actions>
          <Modal.Action htmlType="button" onClick={props.close}>
            Назад
          </Modal.Action>

          <Modal.Action htmlType="submit" disabled={submit.loading}>
            {!submit.loading ? "Удалить" : <LoadingDots size={4}>Удаляем</LoadingDots>}
          </Modal.Action>
        </Modal.Actions>
      </form>
    </Modal>
  );
};

DepositTypeDeleteModal.defaultProps = {};
